import { Adapter as t, getAdapter as r } from "../../../../adapter.js";
import { LoyaltyProgrammeWalletAdapter as o } from "./loyaltyProgrammeWallet/loyaltyProgrammeWallet.adapter.js";
import { LoyaltyProgrammeDesignAdapter as a } from "./loyaltyProgrammeDesign/loyaltyProgrammeDesign.adapter.js";
import { LoyaltyProgrammeSettingsAdapter as m } from "./loyaltyProgrammeSettings/loyaltyProgrammeSettings.adapter.js";
import { LoyaltyProgrammeConfigurationModel as i } from "./loyaltyProgrammeConfiguration.model.js";
class y extends t {
  adapt(e) {
    return new i({
      settings: r(m).adapt(e.settings),
      design: e.design ? r(a).adapt(e.design) : void 0,
      wallet: e.wallet ? r(o).adapt(e.wallet) : void 0
    });
  }
  serialize(e) {
  }
}
export {
  y as LoyaltyProgrammeConfigurationAdapter
};
//# sourceMappingURL=loyaltyProgrammeConfiguration.adapter.js.map
